module.exports = __webpack_public_path__ + "static/media/actor-info-icon.04259f95.svg";